<!-- <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'USER_PROFILE', subPageCode: 'EDIT' }">  
    <div class="main-settings">
        <p-tabView>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
                    <span translate>settings.lbl_user_profile</span>
                </ng-template>
                <div class="flex justify-content-end flex-wrap btn-with-links">
                    <button pButton class="mr-2 bg-white default-text-light-black-color border-button" [label]="'cancel' | translate" (click)="onCancel()"></button>
                    <p-button class="flex align-items-center justify-content-center" [label]="addBtnLabel" (click)="onAddUserProfile()"></p-button>
                </div>
                <div class="card background-not">
                    <div class="font-semibold pb-2">
                        <label class="navigation-item-label font-20" translate>settings.lbl_user_profile_tab</label>
                    </div>
                    <form [formGroup]="profileForm">
                        <div class="grid">
                            <div class="form-field col-6 md:col-10 lg:col-6 field">
                                <label class="flex" translate>lbl_f_name
                                    <span class="required">*</span>
                                </label>
                                <div class="form-control">
                                    <input #nameInput formControlName="firstName" class="p-component p-element w-full" type="text" pInputText appAutoFocus appOnlyLetters appTrimSpacesProfile [placeholder]=" 'settings.lbl_placeholder_first_name' | translate" required/>
                                </div>
                                @if (profileForm.controls.firstName.errors && (profileForm.controls.firstName.dirty || profileForm.controls.firstName.touched)) {
                                    <div class="form-errors mt-1 required-field">
                                        @if(profileForm.controls.firstName.errors?.required){
                                            <div translate>
                                                settings.lbl_first_name_req
                                            </div>
                                        }   
                                        @if(profileForm.controls.firstName.errors?.maxlength){
                                            <div translate>
                                                settings.first_name_max_length
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="form-field col-6 md:col-10 lg:col-6 field">
                                <label class="flex" translate>lbl_l_name
                                    <span class="required">*</span>
                                </label>
                                <div class="form-control">
                                    <input formControlName="lastName" class="p-component p-element w-full" type="text" pInputText appOnlyLetters appTrimSpacesProfile [placeholder]=" 'settings.lbl_placeholder_last_name' | translate" required/>
                                </div>
                                @if (profileForm.controls.lastName.errors && (profileForm.controls.lastName.dirty || profileForm.controls.lastName.touched)){
                                    <div class="form-errors mt-1 required-field">
                                        @if(profileForm.controls.lastName.errors?.required){
                                            <div translate>
                                                settings.lbl_last_name_req
                                            </div>
                                        }   
                                        @if(profileForm.controls.lastName.errors?.maxlength){
                                            <div translate>
                                                settings.last_name_max_length
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="form-field col-6 md:col-10 lg:col-6 field">
                                <label class="flex" translate>settings.lbl_language
                                    <span class="required">*</span>
                                </label>
                                <div class="form-control">
                                    <p-dropdown #dropdown
                                        class="p-component p-element multi-dropdown dropdwon full-width w-full custom-dropdown py-0"
                                        formControlName="language" 
                                        [options]="languages"
                                        optionLabel="label"
                                        optionValue="value"
                                        (onFilter)="onFilter($event)"
                                        [placeholder]=" 'settings.lbl_select_language' | translate">
                                    </p-dropdown>
                                     @if (profileForm.controls.language.errors && (profileForm.controls.language.dirty || profileForm.controls.language.touched)){
                                        <div class="form-errors mt-1 required-field">
                                            @if(profileForm.controls.language.errors?.required){
                                                <div translate>
                                                    settings.lbl_language_validation
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="form-field col-6 md:col-10 lg:col-6 field">
                                <label class="flex" translate>settings.lbl_timezone
                                    <span class="required">*</span>
                                </label>
                                <div class="form-control-container">
                                    <p-dropdown #dropdown
                                        class="p-component p-element w-full"
                                        appendTo="body" 
                                        formControlName="timezone" 
                                        [options]="timeZones"
                                        optionLabel="label"
                                        [placeholder]=" 'settings.lbl_select_timezone' | translate">
                                    </p-dropdown>
                                </div>
                                @if (profileForm.controls.timezone.errors && (profileForm.controls.timezone.dirty || profileForm.controls.timezone.touched)){
                                        <div class="form-errors mt-1 required-field">
                                            @if(profileForm.controls.timezone.errors?.required){
                                                <div translate>
                                                    settings.lbl_timezone_validation
                                                </div>
                                            }
                                        </div>
                                    }
                            </div>
                        </div>
                    </form>
                </div>
                <div class="flex justify-content-end mr-17">
                    <button pButton class="mr-2 mb-2 bg-color-gray default-text-light-black-color border-button" [label]="'cancel' | translate" (click)="onCancel()"></button>
                    <p-button class="mb-2 flex align-items-center justify-content-center" [label]="'label_save' | translate" (click)="onAddUserProfile()"></p-button>
                </div> 
            </p-tabPanel>
        </p-tabView>
    </div>
</div> -->

<!-- <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'USER_PROFILE', subPageCode: 'EDIT' }">   -->
    <div class="flex justify-content-end flex-wrap btn-with-links">
        <button pButton class="mr-2 bg-white default-text-light-black-color cursor-pointer border-button" [label]="'cancel' | translate" (click)="onCancel()"></button>
        <p-button  class="flex align-items-center justify-content-center cursor-pointer event-box" (click)="onNextBtnClick()" [label]="saveUserProfileBtnLabel"></p-button>
    </div>

    <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div class="tab-icons">
              <i class="mi-lg details mr-2"></i>
              <span translate>settings.lbl_user_profile</span>
            </div>
        </ng-template>
         <ng-template pTemplate="body">
            @if(showUserForm) {
                @for(tab of profileAttributeData?.tabs; track tab?.tabCode) {
                      <app-mi-form
                            [attributeLabels]=" attributeLabels "
                            [moduleName]="userProfileModuleName"
                            [attributeValues]="attributeValues"
                            [groups]="tab.groups"
                            [isMultipleFilesUpload]="false"
                            [previousBtnText]="previousBtnLabel"
                            [submitBtnText]="saveUserProfileBtnLabel"
                            (saveData)="saveProfileSettings($event)"
                            [saveBtnId]="'user'"
                            [displaySubmitButtons]="true"
                            [submitBtnText]="saveUserProfileBtnLabel"
                            (previousClick)="onCancel()"
                        >   
                        </app-mi-form>
                    }
            }
         </ng-template>
         
</p-tabPanel>
</p-tabView>

<!-- </div> -->